// These are endpoints for get/post/put methods

// TODO remove OpenAPI toggle code
export const ENDPOINT_PROGRAM = '/api/v2/program/';
export const ENDPOINT_FUNDING_OPPORTUNITY = '/api/v2/fundingOpportunity/';
export const ENDPOINT_CONFIGURATION = '/api/v2/config/';
export const ENDPOINT_ORGANIZATION = '/api/v2/organization/';
export const ENDPOINT_ORGANIZATION_V3 = '/api/v3/organization/';
export const ENDPOINT_ORGANIZATION_RELATIONSHIP = '/api/v2/organizationrelationship/';
export const ENDPOINT_CLOSEOUT = '/api/v1/closeout/';
export const ENDPOINT_GRANT = '/api/v2/grant/';
export const ENDPOINT_INVOICE = '/api/v2/invoice/';
export const ENDPOINT_OBLIGATION = '/api/v2/obligation/';
export const ENDPOINT_COMMITMENT = '/api/v2/commitment/';
export const ENDPOINT_VENDOR = '/api/v2/vendor/';
export const ENDPOINT_SSE = '/api/v2/sse/';
export const ENDPOINT_COMMENT = '/api/v2/comment/';
export const ENDPOINT_COMMUNITY = '/api/v2/community/';
export const ENDPOINT_ALLOCATION = '/api/v2/allocation/';
export const ENDPOINT_ATTACHMENT = '/api/v2/attachment/';
export const ENDPOINT_HISTORY = '/api/v2/history/';
export const ENDPOINT_HISTORY_V2 = '/api/v2/history/';
export const ENDPOINT_PANEL_REVIEW_APPLICATION = '/api/v1/panelreview/application/';
export const ENDPOINT_PANEL_REVIEW_SESSION = (sessionId) =>
  `/api/v1/panelreview/session/${sessionId}`;
export const ENDPOINT_PANEL_REVIEW_SCORES = '/api/v1/panelreview/scores/';
export const ENDPOINT_PANEL_REVIEW_CONFIG = '/api/v1/panelreview/config/';
export const ENDPOINT_PANEL_REVIEW_UPDATE_SUSPENDED_FLAG_REVIEWER_GROUP =
  '/api/v1/panelreview/updateSuspendedFlagForReviewerGroup/';
export const ENDPOINT_PANEL_REVIEW__GROUP_REVIEW = '/api/v1/panelreview/group/review/';
export const ENDPOINT_EHP = '/api/v2/ehp/';
//PanelV2 Endpoints
export const ENDPOINT_PANEL_V2 = '/api/v2/panelreview2/';
export const ENDPOINT_PANEL_V2_SESSION = '/api/v2/panelreview2/sessions/';
export const ENDPOINT_PANEL_V2_SESSIONS = '/api/v2/panelreview2/sessions';
export const ENDPOINT_WORKFLOW = '/api/v3/workflow/';
export const ENDPOINT_WORKFLOW_TASK = '/api/v3/workflow/tasks/';
export const ENDPOINT_DYNAMIC_DATA = '/api/v2/dynamicData/';
export const ENDPOINT_RULES = '/api/v2/rules/';
export const ENDPOINT_TEMPLATES = '/api/v2/template/';
export const ENDPOINT_REFDATA = '/api/v2/ref/refdata/';
export const ENDPOINT_USER = '/api/v2/user/';
export const ENDPOINT_SNAPSHOT = '/api/v2/snapshot/';
export const ENDPOINT_LOCATION = '/api/v2/location';
export const ENDPOINT_SEARCH = '/api/v2/search';
export const ENDPOINT_ANALYTICS = '/api/v2/analytics/';
export const ENDPOINT_ACCOUNT = '/api/v2/account/';
export const ENDPOINT_ACCOUNT_V2 = '/api/v2/account/';
export const ENDPOINT_REGISTRATION = '/api/v2/registration/';

export const ENDPOINT_TRACKER = '/api/v2/tracker/';
export const ENDPOINT_TOGGLE = '/api/v2/toggles';
export const ENDPOINT_PRESCORE_V2 = '/api/v2/prescore';
export const ENDPOINT_DISASTER = '/api/v2/disaster/';
// if ENDPOINT_AUTH changes to bump the version, make a new one hardcoded to v1 so that /saml/ calls can use it these cannot change from v1
export const ENDPOINT_AUTH = '/api/v2/auth/'; // see note
export const ENDPOINT_LOGIN_GOV = '/api/v1/auth/loginGov/';
export const ENDPOINT_ADMIN = '/api/v2/admin/';
export const ENDPOINT_CAMUNDA = '/api/v1/camunda/';